import { ADMIN_API } from '@/api/client'
import type { AuditLogEntry, DatabaseInfo, DocumentOperationRequest, QueryRequest, QueryResponse } from '../types/mongoConsole.types'

const MONGO_API = `${ADMIN_API}/admin/mongo`

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('accessToken')
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  }
}

async function fetchJson<T>(url: string, options?: RequestInit): Promise<T> {
  const res = await fetch(url, { ...options, headers: { ...authHeaders(), ...options?.headers } })
  if (!res.ok) {
    const text = await res.text()
    throw new Error(`${res.status}: ${text}`)
  }
  if (res.status === 204) return undefined as T
  return res.json()
}

export const fetchDatabases = (): Promise<DatabaseInfo[]> =>
  fetchJson(`${MONGO_API}/databases`)

export const queryDocuments = (req: QueryRequest): Promise<QueryResponse> =>
  fetchJson(`${MONGO_API}/query`, { method: 'POST', body: JSON.stringify(req) })

export const getDocument = (database: string, collection: string, documentId: string): Promise<Record<string, unknown>> =>
  fetchJson(`${MONGO_API}/${database}/${collection}/${documentId}`)

export const updateDocument = (
  database: string, collection: string, documentId: string, data: DocumentOperationRequest
): Promise<Record<string, unknown>> =>
  fetchJson(`${MONGO_API}/${database}/${collection}/${documentId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })

export const insertDocument = (
  database: string, collection: string, data: DocumentOperationRequest
): Promise<Record<string, unknown>> =>
  fetchJson(`${MONGO_API}/${database}/${collection}`, { method: 'POST', body: JSON.stringify(data) })

export const deleteDocument = (
  database: string, collection: string, documentId: string, reason: string
): Promise<void> =>
  fetchJson(`${MONGO_API}/${database}/${collection}/${documentId}?reason=${encodeURIComponent(reason)}`, {
    method: 'DELETE',
  })

export const fetchAuditLog = (limit = 50): Promise<AuditLogEntry[]> =>
  fetchJson(`${MONGO_API}/audit?limit=${limit}`)
